import { IPositionCandidate } from '@types';

export enum PrimarySkillsRanking {
  Poor = 'Poor',
  Average = 'Average',
  Good = 'Good',
  VeryGood = 'Very Good',
  Excellent = 'Excellent',
}

// Best to worst — the order the Technical ranking and Soft skills columns sort in.
export const PrimarySkillsRankingOrder: PrimarySkillsRanking[] = [
  PrimarySkillsRanking.Excellent,
  PrimarySkillsRanking.VeryGood,
  PrimarySkillsRanking.Good,
  PrimarySkillsRanking.Average,
  PrimarySkillsRanking.Poor,
];

export const SeniorityOrder = [
  'Trainee',
  'Junior',
  'Junior I',
  'Junior II',
  'Middle',
  'Middle I',
  'Middle II',
  'Senior',
  'Senior I',
  'Senior II',
  'Lead',
  'Architect',
  'CTO',
  'C-level',
];

export const CandidateListGroupingOptions: {
  label: string;
  value:
    | keyof IPositionCandidate
    | 'position'
    | 'workstream'
    | 'workstream-position'
    | 'none';
}[] = [
  { label: 'No grouping', value: 'none' },
  { label: 'Workstream & position', value: 'workstream-position' },
  { label: 'Workstream', value: 'workstream' },
  { label: 'Positions', value: 'position' },
  { label: 'Seniority', value: 'seniority' },
  { label: 'Stage', value: 'status' },
];
